import React, { useEffect, useState } from "react";
import Calendario from "./Calendario";
import { useAuth } from "context/AuthProvider";
import { apiEmpleadosService } from "services/apiEmpleadosService";
import { Card, Col, Row } from "reactstrap";
import CalendarioFiltro from "./CalendarioFiltro";

const CalendarioImpl = () => {
  const { empresa } = useAuth();
 
  const [empleados, setEmpleados] = useState([]);

  const [departamentoId, setDepartamentoId] = useState("TODOS");
  const [anno, setAnno] = useState(new Date().getFullYear());
  const [mes, setMes] = useState(new Date().getMonth().toString());

  const isEmpleadoActivo = (empleado) => {
    if (!empleado?.fechaBaja || empleado.fechaBaja.trim() === "") {
      return true;
    }

    const fechaBaja = new Date(`${empleado.fechaBaja}T00:00:00`);
    if (Number.isNaN(fechaBaja.getTime())) {
      return true;
    }

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    return fechaBaja > hoy;
  };
  

  useEffect(() => {
    const fecthData = async () => {
   
      let response ={content : []}
      if(anno!=="null"){
        if(departamentoId==="TODOS"){
          response = await apiEmpleadosService.getAll(empresa.id,0,1000);
        }else{
          response = await apiEmpleadosService.getAllByDepartamento(departamentoId,0,1000);
        }
        
        setEmpleados((response.content || []).filter(isEmpleadoActivo));
      }
    
    }
    fecthData();

  }, [departamentoId, anno, mes, empresa.id]);

  return (
    <>
     <Card className='shadow'>
      <CalendarioFiltro anno={anno} departamentoId={departamentoId}  setAnno={setAnno} setDepartamentoId={setDepartamentoId} mes={mes} setMes={setMes}></CalendarioFiltro>

      { anno !== "null"&& mes!== "null" ? (
        <>
        <Row className="mt-2">
          <Col>
            <Calendario empleados={empleados} mes={mes} anno={anno}></Calendario>
          </Col>
        </Row>
        </>
      ) : (
        ""
      )}
      </Card>
    </>
  );
};

export default CalendarioImpl;
